import { EditorView } from "@codemirror/view";
import { CM_WIDGET_FONT_FAMILY } from "../shared/theme-helpers";

const COMMENT_ACCENT = "--color-muted-foreground";

export const commentTheme = EditorView.baseTheme({
    ".cm-magic-comment-line": {
        backgroundColor: "transparent",
    },
    ".cm-magic-comment-line-hidden": {
        display: "none",
    },
    ".cm-magic-comment-mark": {
        color: `var(${COMMENT_ACCENT})`,
        fontStyle: "italic",
        opacity: "0.58",
    },
    ".cm-magic-comment-pretty": {
        display: "inline-block",
        maxWidth: "360px",
        whiteSpace: "pre-wrap",
        overflowWrap: "break-word",
        color: `var(${COMMENT_ACCENT})`,
        opacity: "0.46",
        fontFamily: CM_WIDGET_FONT_FAMILY,
        fontSize: "12px",
        fontStyle: "italic",
        fontWeight: "400",
        lineHeight: "1.35",
        verticalAlign: "baseline",
        padding: "0",
        margin: "0",
        cursor: "pointer",
        transition: "opacity 0.12s ease, color 0.12s ease",
        "&:hover": {
            opacity: "0.68",
        },
    },
});
